import { ChakraBox as Box, ChakraFlex as Flex } from "@airhelp/react-ui-components";

interface DotsProps {
  currentSlide: number;
  numberOfSlides: number;
  goToSlide: (slide: number) => void;
  color?: string;
}

export const Dots = ({ currentSlide, numberOfSlides, goToSlide, color = "primary.900" }: DotsProps) => {
  const dots = Array.from(Array(numberOfSlides).keys()).map((i) => {
    const dotColor = i === currentSlide ? color : "greyscale.400";
    const mr = i === numberOfSlides - 1 ? 0 : 4;

    return (
      <Box bg={dotColor} cursor="pointer" w={2} h={2} borderRadius="50%" mr={mr} onClick={() => goToSlide(i)} key={i} />
    );
  });

  return <Flex justify={{ base: "center", md: "left" }}>{dots}</Flex>;
};
